module.exports = __webpack_public_path__ + "static/media/2018_conf_Improving_the_Process_of_Product_Decisions_Making.1a2f67f5.png";